@let btnLabelSendByEmail = "COMPONENT.ESTIMATEUR-BUDGET-SELECTION.SEND_BY_EMAIL" | translate;
@let recentEstimatesData = recentEstimatesProcessed();
@let currentEstimateData = currentEstimate();
@let hasMultipleAppliances = hasSeveralHouseholdAppliances();
<section class="desk:centered-with-padding w-screen py-7 pl-5 desk:pl-0">
  <div
    [class.mb-5]="recentEstimatesData.length < 2"
    class="flex flex-col gap-y-4 rounded-l-3xl bg-gray-light py-5 pl-5 desk:rounded-3xl desk:px-7 desk:py-6">
    <div class="font-title text-[25px]">{{ "COMPONENT.ESTIMATEUR-BUDGET-SELECTION.MY_SELECTION" | translate }}</div>
    <div class="overflow-x-scroll desk:overflow-auto">
      <ul class="inline-flex gap-x-2.5 py-4 pr-5 desk:grid desk:grid-cols-4 desk:gap-5">
        @let estimate = hasMultipleAppliances ? currentEstimateWithoutHouseholdAppliances() : currentEstimateData;
        @for (option of estimate | estimateOptions; track option.id) {
          <li class="h-[190px] w-[175px] desk:h-[214px] desk:w-full">
            <app-option-card-select
              (onEditAction)="redirectToEditPage(option)"
              [image]="option.image"
              [isInEditMode]="true"
              [isPriority]="!isImageInPreviousBlocks && $index < 4"
              [name]="option.name" />
          </li>
          @if ($last && hasMultipleAppliances) {
            <li
              class="flex h-[190px] w-[175px] flex-col justify-between rounded-2xl bg-anis p-2.5 desk:h-[214px] desk:w-full">
              <ul class="flex grow list-disc flex-col justify-center pl-6">
                @for (appliance of currentEstimateHouseholdAppliancesNames(); track $index) {
                  <li>{{ appliance }}</li>
                }
              </ul>
              <div class="drop-shadow-custom flex justify-between overflow-hidden rounded-lg bg-gray-light p-2">
                <span class="font-bold">{{
                  "COMPONENT.ESTIMATEUR-BUDGET-SELECTION.HOUSEHOLD_APPLIANCE" | translate
                }}</span>
                <button (click)="redirectToEditPage(currentEstimateFirstHouseholdAppliance()!)">
                  <app-svg [height]="18" [inline]="true" [width]="18" src="assets/icons/edit.svg" />
                </button>
              </div>
            </li>
          }
        }
      </ul>
    </div>
    @let btnLabelNewEstimate = "COMPONENT.ESTIMATEUR-BUDGET-SELECTION.REQUEST_NEW_ESTIMATE" | translate;
    <app-button
      (onButtonClick)="onNewEstimationClick(btnLabelNewEstimate)"
      [label]="btnLabelNewEstimate"
      class="self-center" />
    <button
      (click)="onSendEstimationClick(currentEstimateData!, btnLabelSendByEmail)"
      class="flex items-center gap-1.5 self-center"
      type="button">
      <span class="text-[14px] font-bold">{{ btnLabelSendByEmail }}</span>
      <app-svg [width]="18" src="assets/icons/mail.svg" />
    </button>
  </div>

  @if (recentEstimatesData.length > 1) {
    <div class="mt-10 font-title text-[25px]">
      {{ "COMPONENT.ESTIMATEUR-BUDGET-SELECTION.MY_ESTIMATIONS" | translate }}
    </div>
    @for (estimateData of recentEstimatesData; track estimateData.original._id; let index = $index) {
      @let estimate = estimateData.original;
      @let estimateId = estimate._id;
      @let minPrice = estimate?._priceEstimate?.total?.min ?? 0;
      @let maxPrice = estimate?._priceEstimate?.total?.max ?? 0;
      @let estimateForOptions =
        estimateData.hasSeveralHouseholdAppliances ? estimateData.withoutHouseholdAppliances : estimate;
      <div
        class="mt-4 flex flex-col gap-y-4 rounded-l-3xl bg-gray-light py-5 pl-5 desk:mt-6 desk:rounded-3xl desk:px-7 desk:py-6">
        <div class="font-title text-[25px]">
          {{ "COMPONENT.ESTIMATEUR-BUDGET-SELECTION.ESTIMATION_INDEX" | translate: { index: index + 1 } }}
        </div>
        @if (minPrice && maxPrice) {
          <div>
            {{
              "COMPONENT.ESTIMATEUR-BUDGET-SELECTION.PRICE_RANGE"
                | translate
                  : {
                      minPrice: minPrice | currency: "EUR" : "symbol" : "1.0-0",
                      maxPrice: maxPrice | currency: "EUR" : "symbol" : "1.0-0",
                    }
            }}
          </div>
        }
        <div class="overflow-x-scroll desk:overflow-auto">
          <ul class="inline-flex gap-x-2.5 py-4 pr-5 desk:grid desk:grid-cols-4 desk:gap-5">
            @for (option of estimateForOptions | estimateOptions; track option.id) {
              <li class="h-[190px] w-[175px] desk:h-[214px] desk:w-full">
                <app-option-card-select
                  (onEditAction)="redirectToEditPage(option, estimateId)"
                  [image]="option.image"
                  [isInEditMode]="true"
                  [name]="option.name" />
              </li>
              @if ($last && estimateData.hasSeveralHouseholdAppliances) {
                <li
                  class="flex h-[190px] w-[175px] flex-col justify-between rounded-2xl bg-anis p-2.5 desk:h-[214px] desk:w-full">
                  <ul class="flex grow list-disc flex-col justify-center pl-6">
                    @for (appliance of estimateData.householdAppliancesNames; track $index) {
                      <li>{{ appliance }}</li>
                    }
                  </ul>
                  <div class="drop-shadow-custom flex justify-between overflow-hidden rounded-lg bg-gray-light p-2">
                    <span class="font-bold">{{
                      "COMPONENT.ESTIMATEUR-BUDGET-SELECTION.HOUSEHOLD_APPLIANCE" | translate
                    }}</span>
                    <button (click)="redirectToEditPage(estimateData.firstHouseholdAppliance!, estimateId)">
                      <app-svg [height]="18" [inline]="true" [width]="18" src="assets/icons/edit.svg" />
                    </button>
                  </div>
                </li>
              }
            }
          </ul>
        </div>
        <button
          (click)="onSendEstimationClick(estimate, btnLabelSendByEmail)"
          class="flex items-center gap-1.5 self-center"
          type="button">
          <span class="text-[14px] font-bold">{{ btnLabelSendByEmail }}</span>
          <app-svg [width]="18" src="assets/icons/mail.svg" />
        </button>
      </div>
    }
  }
</section>
